import { render, staticRenderFns } from "./ProductTable.pug?vue&type=template&id=39528efa&scoped=true&lang=pug&"
import script from "./ProductTable.vue?vue&type=script&lang=js&"
export * from "./ProductTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductTable.scss?vue&type=style&index=0&id=39528efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39528efa",
  null
  
)

export default component.exports